/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import styled from 'styled-components';

import { mediumMediaQuery, smallMediaQuery } from '../../../common/utilities/sizeHelpers';
import { AnimatedLoadingPlaceholder } from '../../common/animatedLoadingPlaceholder/animatedLoadingPlaceholder';

export const HourlyOutdoorIndexLoadingUI = () => {
    return <>
        {Array(...Array(21)).map((x, i) =>  {
            const showBorderBottom = i < 20;
            return  <KeyIndicatorItemLoadingIndicator key={i} showBorderBottom={showBorderBottom}>
                <BarLoadingUI>
                    <AnimatedLoadingPlaceholder width={60} height={'18px'}/>
                </BarLoadingUI>
                <CirlceLoadingUI>
                    <AnimatedLoadingPlaceholder width={30} height='30px' radius={16} />
                </CirlceLoadingUI>
                <CirlceLoadingUI>
                    <AnimatedLoadingPlaceholder width={30} height='30px' radius={16} />
                </CirlceLoadingUI>
                <BarLoadingUI>
                    <AnimatedLoadingPlaceholder width={60} height={'18px'}/>
                </BarLoadingUI>
                <BarLoadingUI>
                    <AnimatedLoadingPlaceholder width={60} height={'18px'}/>
                </BarLoadingUI>
            </KeyIndicatorItemLoadingIndicator>;}
        )}
    </>;
};

const KeyIndicatorItemLoadingIndicator = styled.div.attrs((props: {showBorderBottom: boolean;}) => props)`
    display: flex;
    flex-direction: row;
    width: 100%;
    border-bottom: ${(props) => props.showBorderBottom ? '1px solid #EEEEEE': '' };
    padding: 10px 20px;
    justify-content: space-between;
`;

const CirlceLoadingUI = styled.div`
    padding: 8px 0 8px 10px;

    @media ${mediumMediaQuery} {
        padding-top: 7px;
    }

    @media ${smallMediaQuery} {
        padding-top: 6px;
    }
`;

const BarLoadingUI = styled.div`
    padding: 14px 0 8px 15px;

    @media ${mediumMediaQuery} {
        padding-top: 13px;
    }
`;
